<template>
	<div class="file-list-view">
		<div class="file" v-for="(file, i) in items" v-bind:key="i" @click="open(file)">
			{{ file.label }}
			<div>
				<div @click.stop="rename(file)">Omdøb</div>
				<div @click.stop="copy(file)">Kopi</div>
				<div @click.stop="del(file)">Slet</div>
			</div>
		</div>
		<div class="btn" @click="create">Opret</div>
	</div>
</template>

<script>
	import { bus } from "../../bus"

	export default {
		data() {
			return {
				items: []
			};
		},
		props: {
			value: {
				type: Array,
				default() {
					return [];
				}
			},
			controller: {
				type: Object
			}
		},
		methods: {
			async del(file) {
				await this.controller.delete(this, file.id);
			},
			async copy(file) {
				await this.controller.copy(this, file.id);
			},
			async rename(file) {
				var name = prompt('Navn', file.label);

				if (name == '') return;

				var obj = Object.assign({}, file);
				obj.label = name;

				await this.controller.save(this, obj);
			},
			async create() {
				await this.controller.open(this);
			},
			async open(file) {
				await this.controller.open(this, file.id);
			},
			async update() {
				this.items = (await this.axios.get('/templates/')).data._items;

				//console.log('items', this.items);
			}
		},
		mounted() {
			var self = this;

			bus.$on('update-template', function () {
				self.update();
			});

			self.update();
		}
	}
</script>

<style lang="scss" scoped>
	.file-list-view {
		overflow: hidden;

		& > input {
			position: absolute;
			left: -500px;
		}

		& > .file {
			position: relative;
			border: 1px solid #2d2f36;
			line-height: 40px;
			text-align: left;
			padding-left: 10px;
			margin-bottom: 10px;
			cursor: pointer;

			& > div {
				position: absolute;
				top: 0;
				right: 0;

				& > div {
					display: inline-block;
					margin-right: 15px;
					font-size: 12px;
				}
			}
		}

		& > .btn {
			background-color: #202127;
			line-height: 40px;
			text-align: center;
			margin-bottom: 10px;
			cursor: pointer;
		}
	}
</style>